import { render, staticRenderFns } from "./FAQAdministrateur.vue?vue&type=template&id=620aa47c&scoped=true&"
var script = {}
import style0 from "./FAQ.scss?vue&type=style&index=0&id=620aa47c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620aa47c",
  null
  
)

export default component.exports